document.addEventListener('DOMContentLoaded', function () {

  // Scroll reveal
  const obs = new IntersectionObserver(entries => {
    entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('vis'); });
  }, { threshold: .08 });
  document.querySelectorAll('.reveal').forEach(el => obs.observe(el));

  // Gallery thumbnails
  document.querySelectorAll('.gallery-thumb').forEach(t => {
    t.addEventListener('click', function () {
      const img = this.querySelector('img');
      const main = document.querySelector('.gallery-main img');
     if (img && main) main.src = img.src.replace('200x200', '2048x2048');
      document.querySelectorAll('.gallery-thumb').forEach(x => x.classList.remove('active'));
      this.classList.add('active');
    });
  });

  // Variant selection — connects buttons to hidden select AND updates price/availability
  document.querySelectorAll('.var-btn').forEach(btn => {
    btn.addEventListener('click', function () {
      // Update active button UI
      this.closest('.var-opts')?.querySelectorAll('.var-btn').forEach(b => b.classList.remove('active'));
      this.classList.add('active');

      // Find all selected values across all option groups
      const allSelected = [];
      document.querySelectorAll('.var-opts').forEach(group => {
        const active = group.querySelector('.var-btn.active');
        if (active) allSelected.push(active.textContent.trim());
      });

      // Match to variant select
      const select = document.querySelector('select[name="id"]');
      if (select) {
        const options = Array.from(select.options);
        // Try to find a variant that matches all selected values
        const match = options.find(opt => {
          return allSelected.every(val => opt.text.includes(val));
        }) || options.find(opt => opt.text.includes(allSelected[allSelected.length - 1]));

        if (match) {
          select.value = match.value;
          // Trigger change event so Shopify picks it up
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  });

  // Auto-select first variant on load
  const firstBtns = document.querySelectorAll('.var-opts');
  firstBtns.forEach(group => {
    const first = group.querySelector('.var-btn');
    if (first) first.click();
  });

});
